import { useEffect, useRef } from 'react'

/**
 * A custom hook to track the previous value of a state or prop.
 * @param {T} value The current value to track.
 * @returns {T | undefined} The previous value.
 */
export function usePrevious<T>(value: T) {
  const ref = useRef<T>(undefined)

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}
